import { useState } from "react";
import { useClient } from "./ClientProvider";
import api from "../services/api";
import { notifyError, notifySucces } from "../utils/notifications";
import {
  INSURANCE_ADHESION_PUSH_DESCRIPTION,
  INSURANCE_ADHESION_PUSH_JOURNEY,
  INSURANCE_ADHESION_PUSH_SUCCESS,
  INSURANCE_ADHESION_PUSH_TITLE,
} from "../helpers/getInsuranceAdhesionActionVisibility";

export function useSendInsuranceAdhesionPush() {
  const { client, refreshClientV2 } = useClient();
  const [sendingInsurancePush, setSendingInsurancePush] = useState(false);

  const sendInsuranceAdhesionPush = async () => {
    const cpf = client?.client?.cpf;
    if (!cpf) {
      notifyError("CPF do portador não encontrado");
      return;
    }

    try {
      setSendingInsurancePush(true);
      const response = await api.post("push-api/notificacoes", {
        jornada: INSURANCE_ADHESION_PUSH_JOURNEY,
        cpf,
        client_id: client?.client?.id,
        titulo: INSURANCE_ADHESION_PUSH_TITLE,
        descricao: INSURANCE_ADHESION_PUSH_DESCRIPTION,
      });

      const statusCode = Number(response?.statusCode);
      if (Number.isFinite(statusCode) && statusCode !== 200) {
        notifyError(
          response?.detail ||
            response?.message ||
            "Falha ao enviar link de contratação de seguro"
        );
        return;
      }

      notifySucces(INSURANCE_ADHESION_PUSH_SUCCESS);
      if (refreshClientV2) await refreshClientV2();
    } catch (error) {
      const message =
        error instanceof Error ? error.message : undefined;
      notifyError(message || "Falha ao enviar link de contratação de seguro");
    } finally {
      setSendingInsurancePush(false);
    }
  };

  return { sendInsuranceAdhesionPush, sendingInsurancePush };
}
